import React, { FC } from 'react';
import { CardContent, Card, Box, Typography, Button } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import * as colors from '../../../utils/styles/colors';
import zoomSdk from '@zoom/appssdk';

type ICardAlertContainer = {
  mainText?: string;
  severity: 'success' | 'error' | 'warning';
  linkText?: string;
  url?: string;
};

const CardAlertContainer: FC<ICardAlertContainer> = ({
  mainText,
  severity,
  linkText,
  children,
  url,
}) => {
  const cardType = {
    success: {
      background: colors.SUCCESS_BACKGROUND,
      border: colors.SUCCESS_HIGHLIGHT,
      link: 'success.main',
    },
    error: {
      background: colors.ERROR_BACKGROUND,
      border: colors.ERROR_HIGHLIGHT,
      link: colors.ERROR_HIGHLIGHT,
    },
    warning: {
      background: 'error.light',
      border: colors.WARNING_HIGHLIGHT,
      link: colors.WARNING_LINK,
    },
  };

  const handleOpenUrl = () => {
    if (url)
      zoomSdk.openUrl({
        url,
      });
  };

  const CustomBell = () => (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_5127_329116)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.9997 3C11.1713 3 10.4997 3.67157 10.4997 4.5C10.4997 4.72108 10.5472 4.93048 10.6328 5.11911C11.0809 5.04026 11.5387 5 11.9997 5C12.4608 5 12.9186 5.04027 13.3667 5.11911C13.4523 4.93048 13.4997 4.72109 13.4997 4.5C13.4997 3.67157 12.8281 3 11.9997 3ZM15.2804 5.72147C15.4221 5.34107 15.4997 4.92938 15.4997 4.5C15.4997 2.567 13.9327 1 11.9997 1C10.0667 1 8.49972 2.567 8.49972 4.5C8.49972 4.92938 8.57731 5.34107 8.71904 5.72147C8.13314 5.99625 7.58766 6.34658 7.10215 6.76736C5.77751 7.91537 4.99972 9.50571 4.99972 11.2C4.99972 13.3077 4.47946 14.7999 3.867 15.8357L3.8568 15.853C3.463 16.5189 3.15544 17.0391 2.94915 17.4125C2.84604 17.5991 2.7553 17.7721 2.68934 17.9203C2.65662 17.9937 2.62054 18.0819 2.59242 18.1756C2.57146 18.2454 2.51988 18.4265 2.54133 18.6459C2.55311 18.7664 2.58013 19.0057 2.71947 19.25C2.8588 19.4942 3.05103 19.6393 3.14875 19.7108C3.308 19.8272 3.46735 19.8772 3.54671 19.8991C3.64037 19.9251 3.73139 19.9404 3.80685 19.9505C3.95773 19.9707 4.13341 19.981 4.31652 19.9873C4.68156 20 5.19195 20 5.83508 20H8.12574C8.56978 21.7252 10.1359 23 11.9997 23C13.8636 23 15.4297 21.7252 15.8737 20H18.1644C18.8075 20 19.3179 20 19.6829 19.9873C19.866 19.981 20.0417 19.9707 20.1926 19.9505C20.2681 19.9404 20.3591 19.9251 20.4527 19.8991C20.5321 19.8772 20.6914 19.8272 20.8507 19.7108C20.9484 19.6393 21.1406 19.4942 21.28 19.25C21.4193 19.0057 21.4463 18.7664 21.4581 18.6459C21.4796 18.4265 21.428 18.2454 21.407 18.1756C21.3789 18.0819 21.3428 17.9937 21.3101 17.9203C21.2441 17.7721 21.1534 17.5991 21.0503 17.4125C20.844 17.0391 20.5364 16.5189 20.1426 15.8528L20.1324 15.8357C19.52 14.7999 18.9997 13.3077 18.9997 11.2C18.9997 9.50571 18.2219 7.91537 16.8973 6.76736C16.4118 6.34658 15.8663 5.99625 15.2804 5.72147ZM13.5139 7.19808C13.5266 7.2018 13.5393 7.20526 13.552 7.20846C14.3215 7.42057 15.0209 7.78776 15.5874 8.27873C16.5132 9.08109 16.9997 10.136 16.9997 11.2C16.9997 13.6559 17.6112 15.5012 18.4109 16.8537C18.686 17.3189 18.9089 17.696 19.0833 17.998C18.824 18 18.5127 18 18.1415 18H5.85791C5.48677 18 5.17545 18 4.91617 17.998C5.09055 17.696 5.31349 17.3189 5.58856 16.8537C6.38824 15.5012 6.99972 13.6559 6.99972 11.2C6.99972 10.136 7.48621 9.08109 8.41201 8.27873C8.97852 7.78776 9.67795 7.42057 10.4474 7.20846C10.4602 7.20526 10.4729 7.2018 10.4855 7.19809C10.9684 7.06859 11.4783 7 11.9997 7C12.5212 7 13.031 7.06858 13.5139 7.19808ZM10.2673 20C10.6131 20.5978 11.2594 21 11.9997 21C12.74 21 13.3863 20.5978 13.7322 20H10.2673Z'
          fill='#FFCF87'
        />
      </g>
      <defs>
        <clipPath id='clip0_5127_329116'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );

  const cardIcon = () => {
    switch (severity) {
      case 'success':
        return (
          <CheckCircleOutlineIcon sx={{ color: cardType[severity].border }} />
        );
      case 'error':
        return <ErrorOutlineIcon sx={{ color: cardType[severity].border }} />;
      case 'warning':
        return <CustomBell />;
    }
  };

  return (
    <Card
      id='card-alert-container'
      sx={{
        bgcolor: cardType[severity].background,
        borderRadius: '8px',
        boxShadow: 0,
        width: '80%',
        '@media (max-width: 375px)': {
          width: '90%',
        },
        boxSizing: 'border-box',
        overflow: 'visible',
        border: 'solid',
        borderWidth: '1px',
        borderColor: cardType[severity].border,
      }}
    >
      <CardContent
        id='card-alert-content'
        sx={{
          display: 'flex',
          flexDirection: 'row',
          padding: '12px',
          '&.MuiCardContent-root:last-child': {
            paddingBottom: '12px',
          },
        }}
      >
        <Box id='card-alert-icon'>{cardIcon()}</Box>
        <Typography
          id='card-alert-text'
          sx={{
            color: 'black',
            textAlign: 'left',
            lineHeight: '20px',
            fontSize: '14px',
            marginLeft: '12px',
          }}
        >
          {mainText || children}
          {linkText && (
            <Button
              id='card-alert-button'
              onClick={handleOpenUrl}
              style={{
                textDecoration: 'underline',
                textTransform: 'none',
                fontStyle: 'normal',
                color: cardType[severity].link,
                textDecorationColor: cardType[severity].link,
                backgroundColor: 'transparent',
                padding: 0,
                textAlign: 'left',
                textUnderlineOffset: '3px',
              }}
            >
              {linkText}
            </Button>
          )}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default CardAlertContainer;
